import React from "react";
import { useTranslation } from "react-i18next";
import ParentCompanyDTO from "features/parentCompany/dtos/ParentCompanyDTO";
import CommodityIcon from "features/shared/components/icons/CommodityIcon";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { ContactType } from "features/customer/enums/contactType";

type Props = { contact: ParentCompanyDTO };

const ParentCompanySupplierContact = ({ contact }: Props) => {
  const tLabels = useTranslation("parentCompany\\parentCompany").t;
  const contacts = contact.parentCompanyContact ?? [];

  const emails = contacts.filter(c => c.contactType === ContactType.Email);
  const phones = contacts.filter(c => c.contactType === ContactType.Phone || c.contactType === ContactType.Mobile);
  const urls   = contacts.filter(c => c.contactType === ContactType.Url);

  const normalizeHref = (u?: string) => u && /^https?:\/\//i.test(u) ? u : (u ? `https://${u}` : "");

  const renderContacts = (list: typeof contacts) =>
    list.length ? (
      <div>
        {list.map((c, i) => (
          <div key={i} className="d-flex align-items-center mb-1">
            {c.commodityDetail !== undefined &&
              c.commodityDetail !== CommodityDetail.Undefined && (
                <span className="mr-2 d-flex align-items-center">
                  <CommodityIcon commodityDetail={c.commodityDetail} size="sm" includeColor />
                </span>
              )}

            {c.contactType === ContactType.Url ? (
              <a href={normalizeHref(c.value)} target="_blank" rel="noopener noreferrer" className="text-break" title={c.value}>
                {c.value}
              </a>
            ) : (
              <span>{c.value}</span>
            )}
          </div>
        ))}
      </div>
    ) : (
      <span className="text-muted">—</span>
    );


  return (
    <>
      <hr className="mt-3" />
      <div className="row justify-content-around align-items-start">
        <div className="col-12 col-sm-6 col-xl-3 mb-3 px-3 text-left">
          <InfoItem
            title={tLabels("supplierContacts.email")}
            icon="envelope"
            value={renderContacts(emails)}
          />
        </div>
        <div className="col-12 col-sm-6 col-xl-3 mb-3 px-3 text-left">
          <InfoItem
            title={tLabels("supplierContacts.phone")}
            icon="phone"
            value={renderContacts(phones)}
          />
        </div>
        <div className="col-12 col-sm-6 col-xl-3 mb-3 px-3 text-left">
          <InfoItem
            title={tLabels("supplierContacts.url")}
            icon="globe"
            value={renderContacts(urls)}
          />
        </div>
      </div>
    </>
  );
};

export default ParentCompanySupplierContact;
